// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"06b9e9c5","453":"9977636c","455":"548db57d","977":"67f52f13"}[chunkId] + ".chunk.js";
};